import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { PatientState } from "../../data/atoms";
import { TugScore } from "../../models/reports";
import { convertDOBintoAge, getPatientAge } from "../../utils/sharedFunction";
import CustomBarGraph from "../Graphs/CustomBarGraph";
interface Props {
  score: TugScore;
}

const TugTest: React.FC<Props> = ({ score }) => {
  const patientInfo = useRecoilValue(PatientState);
  console.log("Tug_Test score: ", score);

  let totalTimeTug = {
    graphName: "TotalTimeTug",
    graphSVG: (
      <svg
        width="47"
        height="47"
        viewBox="0 0 47 47"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_7280_3165)">
          <path
            d="M25.2605 6.45947V5.95947H24.7605H22.1605H21.6605V6.45947V20.931V21.247L21.9459 21.3826L31.3394 25.8471L31.791 26.0617L32.0057 25.6102L33.1218 23.2619L33.3364 22.8103L32.8848 22.5956L25.2605 18.972V6.45947Z"
            fill="white"
            stroke="white"
          />
          <circle cx="23.5" cy="19.5" r="18.5" fill="black" />
          <path
            d="M23.5 0C12.7305 0 4 8.73047 4 19.5C4 30.2695 12.7305 39 23.5 39C34.2695 39 43 30.2695 43 19.5C43 8.73047 34.2695 0 23.5 0ZM23.5 36.4C14.1664 36.4 6.6 28.8336 6.6 19.5C6.6 10.1664 14.1664 2.6 23.5 2.6C32.8336 2.6 40.4 10.1664 40.4 19.5C40.4 28.8336 32.8336 36.4 23.5 36.4Z"
            fill="black"
          />
          <path
            d="M25.2605 6.45947V5.95947H24.7605H22.1605H21.6605V6.45947V20.931V21.247L21.9459 21.3826L31.3394 25.8471L31.791 26.0617L32.0057 25.6102L33.1218 23.2619L33.3364 22.8103L32.8848 22.5956L25.2605 18.972V6.45947Z"
            fill="white"
            stroke="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_7280_3165"
            x="0"
            y="0"
            width="47"
            height="47"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_7280_3165"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_7280_3165"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    graphTitle: "Total Time",
    graphTitleDesc: "",
    graphNormValue: 0,
    isgraphNorm: false,
    graphActualValue: [
      score?.timing.totalTime > 1000
        ? score?.timing.totalTime / 1000
        : score?.timing.totalTime,
    ],
    graphActualValueLabel: [
      `${(score?.timing.totalTime > 1000 ? score?.timing.totalTime / 1000 : score?.timing.totalTime).toPrecision(2)}`,
    ],
    graphRange: [4, 8, 12, 16],
    graphRangeLabel: ["4", "8", "12", "16"],
    graphNoLines: [],
    minMax: false,
    graphUnit: "Seconds",
    graphAge: convertDOBintoAge(new Date(patientInfo?.dob)),
  };
  let numberOfStepsOption = {
    graphName: "NumbersOfSteps",
    graphSVG: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="49"
        height="36"
        viewBox="0 0 49 36"
        fill="none"
      >
        <g filter="url(#filter0_d_4669_308)">
          <path
            d="M8.30103 14.8873C9.80847 17.4983 13.8029 20.9639 13.8029 20.9639L20.6651 19.0374C19.5292 17.0699 19.7243 15.6815 19.9195 14.293C20.1146 12.9045 20.3098 11.516 19.1739 9.54858C17.8392 7.23684 14.1512 2.57544 9.86232 3.77949C5.57347 4.98354 6.02923 10.9525 8.30103 14.8873ZM20.2631 25.2471C22.1555 24.7158 23.015 23.1075 22.1796 21.6606L21.4223 20.349L14.5602 22.2755L15.3174 23.5871C16.1528 25.034 18.3706 25.7784 20.2631 25.2471ZM38.7787 12.428C36.5069 8.49307 30.9046 3.969 26.6157 5.17305C22.3269 6.37709 24.2994 11.5201 25.6341 13.8318C26.77 15.7993 28.2903 16.7061 29.8107 17.613C31.3311 18.5199 32.8515 19.4267 33.9874 21.3942L40.8495 19.4677C40.8495 19.4677 40.2862 15.0389 38.7787 12.428ZM40.4475 25.6774C42.34 25.1462 43.1994 23.5378 42.3641 22.0909L41.6068 20.7793L34.7446 22.7058L35.5019 24.0174C36.3373 25.4643 38.5551 26.2087 40.4475 25.6774Z"
            fill="black"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_4669_308"
            x="0.423875"
            y="0.494286"
            width="48.4394"
            height="34.6242"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="3.08982" />
            <feGaussianBlur stdDeviation="3.08982" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4669_308"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_4669_308"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    graphTitle: "Number of Steps",
    graphTitleDesc: "",
    graphNormValue: 0,
    isgraphNorm: false,
    graphActualValue: [score?.gait.numberOfSteps],
    graphActualValueLabel: [`${score?.gait.numberOfSteps}`],
    graphRange: [5, 10, 15, 20],
    graphRangeLabel: ["5", "10", "15", "20"],
    graphNoLines: [],
    minMax: false,
    graphUnit: "",
    graphAge: convertDOBintoAge(new Date(patientInfo?.dob)),
  };
  console.log("Tug Test Score:", score);
  return (
    <>
      {score &&
        score?.timing.totalTime != 0 &&
        !isNaN(score?.timing.totalTime) && (
          <CustomBarGraph options={totalTimeTug} />
        )}
      {score &&
        score?.gait.numberOfSteps != 0 &&
        !isNaN(score?.gait.numberOfSteps) && (
          <CustomBarGraph options={numberOfStepsOption} />
        )}
    </>
  );
};

export default TugTest;
